
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { defineComponent, ref, toRefs } from "vue";

interface MergeOptions {
  closeClickDimmed: boolean;
  closeKeyCode: number | false;
  styleModalContent: { [key: string]: unknown };
}

const __default__ = defineComponent({
  inheritAttrs: false,
  props: {
    close: { type: Function, default: () => {} },
    options: { type: Object, default: () => ({}) },
    modelValue: { type: Boolean, default: true },
    maxWidth: { type: Number, default: 30 },
    styleClass: {
      type: Object,
      default: () => ({ background: "rgba(0, 0, 0, 0.5)" }),
    },
    styleClassContain: { type: Object, default: () => ({}) },
    offEvent: { type: Boolean, default: true },
    modalClass: { type: String, default: "" },
    className: { type: String, default: "" },
    heightModal: { type: String, default: "100vh - 150px" },
  },
  emits: [
    "close",
    "before-enter",
    "enter",
    "after-enter",
    "enter-cancelled",
    "before-leave",
    "leave",
    "after-leave",
    "leave-cancelled",
    "close-modal",
    "scroll-modal",
  ],
  setup(props, context) {
    const { options, modelValue } = toRefs(props);
    const modalRef = ref(null);
    const show = ref(modelValue.value);
    const mergeOptions: MergeOptions = {
      closeClickDimmed: true,
      closeKeyCode: 27,
      styleModalContent: {},
      ...options.value,
    };
    const onTransitionEmit = {
      beforeEnter: () => context.emit("before-enter"),
      enter: () => context.emit("enter"),
      afterEnter: () => context.emit("after-enter"),
      enterCancelled: () => context.emit("enter-cancelled"),
      beforeLeave: () => context.emit("before-leave"),
      leave: () => context.emit("leave"),
      afterLeave: () => {
        context.emit("after-leave");
      },
      leaveCancelled: () => context.emit("leave-cancelled"),
    };

    return {
      mergeOptions,
      modalRef,
      onTransitionEmit,
      show,
    };
  },
  watch: {
    modelValue() {
      const isShow = this.modelValue;
      this.show = isShow;

      if (isShow) this.listeningEvent();
      else this.removeListeningEvent();
    },
  },
  mounted() {
    this.listeningEvent();
  },
  onDestoryed() {
    this.removeListeningEvent();
  },
  methods: {
    closeModal() {
      this.close();
      this.$emit("close-modal");
    },
    listeningEvent() {
      EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ESC, () => this.close());
      EventEmitter.on(
        EmitterEvents.EVENT_SWITCH_ORG,
        () => typeof close === "function" && this.close(),
      );
    },
    removeListeningEvent() {
      this.$props.offEvent &&
        EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ESC);
      EventEmitter.off(EmitterEvents.EVENT_SWITCH_ORG);
    },
    onscroll(e) {
      this.$emit("scroll-modal", e);
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "73843e73": (_ctx.heightModal)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__